import { jsxs, jsx } from 'react/jsx-runtime';
import { isPresetGradientColor } from '@flex-design-system/fx-colors';
import { forwardRef } from 'react';
import { getColor } from '../utils/color.mjs';
import useId from './hooks/useId.mjs';
import { getID, FlexLinearGradient } from './shared/FlexLinearGradient.mjs';

const ExclamationmarkOctagonIcon = forwardRef(
  ({
    color: rawColor = "currentColor",
    size: sizeFromProps,
    type = "default",
    style,
    ...props
  }, forwardedRef) => {
    const { id } = useId();
    const isGradient = isPresetGradientColor(rawColor);
    const color = isGradient ? `url(#${getID(rawColor, id)})` : getColor(rawColor);
    const size = sizeFromProps ?? 24;
    if (type === "fill") {
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: size,
          height: size,
          fill: "none",
          viewBox: "0 0 24 24",
          ...props,
          ref: forwardedRef,
          style: sizeFromProps !== void 0 ? { width: size, height: size, flexShrink: 0, ...style } : { flexShrink: 0, ...style },
          children: [
            isGradient && /* @__PURE__ */ jsx(FlexLinearGradient, { id }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "m8.074 20.751.625.249h6.602l.625-.249 4.79-4.53.284-.662V8.765l-.262-.64-4.79-4.853L15.301 3H8.699l-.648.27-4.789 4.855L3 8.764v6.796l.285.66 4.789 4.531ZM11.1 13.1v-5h1.8v5h-1.8Zm0 3v-2h1.8v2h-1.8Z",
                fillRule: "evenodd",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
    if (type === "default") {
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: size,
          height: size,
          fill: "none",
          viewBox: "0 0 24 24",
          ...props,
          ref: forwardedRef,
          style: sizeFromProps !== void 0 ? { width: size, height: size, flexShrink: 0, ...style } : { flexShrink: 0, ...style },
          children: [
            isGradient && /* @__PURE__ */ jsx(FlexLinearGradient, { id }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "m8.074 20.751.625.249h6.602l.625-.249 4.79-4.53.284-.662V8.765l-.262-.64-4.79-4.853L15.301 3H8.699l-.648.27-4.789 4.855L3 8.764v6.796l.285.66 4.789 4.531Zm1-1.604-4.221-3.993V9.15l4.24-4.298h5.813l4.241 4.298v6.003l-4.221 3.993H9.075Z",
                fillRule: "evenodd",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M11.09 13.011V7.955h1.82v5.056h-1.82ZM11.09 16.045v-2.023h1.82v2.023h-1.82Z",
                fillRule: "evenodd",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
    console.error(
      `ExclamationmarkOctagonIcon doesn't support the combination of ${size} and ${type}`
    );
    return null;
  }
);

export { ExclamationmarkOctagonIcon };
//# sourceMappingURL=ExclamationmarkOctagonIcon.mjs.map
